if (!customElements.get('variant-card-swatches')) {
  class VariantCardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      this.buttons = Array.from(this.querySelectorAll('.card-variant-swatches__button'));
      if (!this.card || !this.buttons.length) return;

      this.image = this.card.querySelector('.card__media .media > img:first-child');
      this.links = Array.from(this.card.querySelectorAll('a.full-unstyled-link'));
      this.activeButton = this.querySelector('.card-variant-swatches__button.is-active') || this.buttons[0];

      this.buttons.forEach((button) => {
        button.addEventListener('mouseenter', () => this.preview(button));
        button.addEventListener('focus', () => this.preview(button));
        button.addEventListener('click', () => this.select(button));
      });

      this.addEventListener('mouseleave', () => this.preview(this.activeButton));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.preview(this.activeButton);
      });
    }

    preview(button) {
      if (!button) return;
      const src = button.dataset.imageSrc;
      if (this.image && src) {
        this.image.src = src;
        if (button.dataset.imageSrcset) this.image.srcset = button.dataset.imageSrcset;
      }
    }

    select(button) {
      this.activeButton = button;
      this.buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const url = button.dataset.variantUrl;
      if (url) this.links.forEach((link) => { link.href = url; });
      this.preview(button);
    }
  }

  customElements.define('variant-card-swatches', VariantCardSwatches);
}
